import { USPS_STATE_CODES } from './AddressForm.constants';
export function getCountryOptions() {
  return USPS_STATE_CODES.map(function (state) {
    return {
      text: state,
      value: state
    };
  });
}